<app-logo-header></app-logo-header>
<section class="section">
  <div class="container">
    <div class="success-card mx-auto p-3">
      <div class="text-center mb-3">
        <img src="../../../../../assets/images/easykash-logo.png" />
      </div>
      <div class="card shadow-lg p-3 mb-3">
        <div class="text-center">
          <svg aria-hidden="true" focusable="false" data-prefix="fad" height="48" width="48"
               data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g class="fa-group">
              <path fill="#2eca8b" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm155.31 195.31l-184 184a16 16 0 0 1-22.62 0l-104-104a16 16 0 0 1 0-22.62l22.62-22.63a16 16 0 0 1 22.63 0L216 308.12l150.06-150.06a16 16 0 0 1 22.63 0l22.62 22.63a16 16 0 0 1 0 22.62z" class="fa-secondary"></path>
              <path fill="#198754" d="M227.31 387.31a16 16 0 0 1-22.62 0l-104-104a16 16 0 0 1 0-22.62l22.62-22.63a16 16 0 0 1 22.63 0L216 308.12l150.06-150.06a16 16 0 0 1 22.63 0l22.62 22.63a16 16 0 0 1 0 22.62l-184 184z"></path>
            </g>
          </svg>
          <h5 class="text-success fw-bold">Congratulations!</h5>
        </div>
        <p>{{ 'PROVIDER.CASH.MESSAGE1' | translate }} <span class="text-decoration-underline fw-bold">{{ data.referenceNumber }}</span></p>
        <p>{{ 'PROVIDER.CASH.MESSAGE2' | translate: {voucher: data?.voucher} }}</p>
      </div>
      <div class="d-flex">
        <button (click)="onContinueClick()" class="btn btn-success col-12">Continue</button>
      </div>
    </div>
    <app-receipt></app-receipt>
  </div>
</section>
